import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { MoveBatchDocumentsIntoFolder } from '../../../patients/actions/PatientActions';
//import { CancelButton } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect } from "../../../../components/reduxFields";
import { CommonButton } from "../../../../components/buttons";

const validate = (values) => {
    const errors = {};
    if (!values.masterFolderId) {
      errors.masterFolderId = 'Please select folder.';
    }
    return errors;
  };
  

class MoveBatchDocumentsIntoFolderModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            selectedDocumentIds: (props.selectedDocumentIds && props.selectedDocumentIds.length > 0  ? props.selectedDocumentIds : []),
            userDocumentSubFoldersFiltered: [],
        };
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
    }

    handleClose = () => {
        this.props.closeDialog();
    };

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    onSubmitHandler(formData) {
        let postData = {
          documentIds: this.props.selectedDocumentIds,         
          masterFolderId: formData.masterFolderId,
          subFolderId: formData.subFolderId || null,
        };
        //console.log(JSON.stringify(postData));
        this.props.MoveBatchDocumentsIntoFolder(postData.documentIds.toString(), postData.masterFolderId, postData.subFolderId);
        this.handleClose();
      }
    

    handleNewRequest(input, selectedValue, label) {
        input.onChange(selectedValue.value);    
        if(label === 'FOLDER')
        { 
            let userDocumentSubFoldersFiltered = this.props.userDocumentSubFolders.filter((obj) => obj.masterFolderId === selectedValue.value);
            this.setState({
                userDocumentSubFoldersFiltered: userDocumentSubFoldersFiltered
            });
        }
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const { handleSubmit } = this.props;
        const actions = [
        <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={() => this.handleClose()} />,
        <CommonButton type="submit" primary={true} label="Move Document" onTouchTap={handleSubmit(this.onSubmitHandler)} />,
        ];
        return (
            <Dialog
                className="custom_modal"
                title="Move Batch Documents into Folder"
                modal={false}
                open={this.state.open}
                actions={actions}
                autoScrollBodyContent={true}
            >
                <div className="row">
                    <div className="col-sm-12">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                            <div className="row">
                                <div className="col-sm-12 require" style={{ marginTop: '50px' }}>
                                    <Field
                                        name={`masterFolderId`}
                                        hintText="Folder"
                                        handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue, 'FOLDER')}
                                        options={this.props.userDocumentMasterFolders}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                <div className="col-sm-12" style={{ marginTop: '50px' }}>
                                    <Field
                                        name={`subFolderId`}
                                        hintText="Sub Folder"
                                        handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue, 'SUB FOLDER')}
                                        options={this.state.userDocumentSubFoldersFiltered}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Dialog>
        );
    }
}

MoveBatchDocumentsIntoFolderModal = reduxForm({
    form: 'MoveBatchDocumentsIntoFolderModalForm',
    validate,
    enableReinitialize: true,
})(MoveBatchDocumentsIntoFolderModal);


function mapStateToProps(state, ownProps) {
    return {
        loading: false 
    }
}

export default connect(mapStateToProps, {MoveBatchDocumentsIntoFolder})(MoveBatchDocumentsIntoFolderModal);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/uploadDocuments/MoveBatchDocumentsIntoFolderModal.js